Object.defineProperty(exports, '__esModule', {
  value: true
});
(function (Brand) {
  Brand["Bsm"] = "BSM";
  Brand["Aad"] = "AAD";
})(exports.Brand || (exports.Brand = {}));